<template>
  <!-- v-show="!noNav" -->
  <div
    class="g-breadcrumb"
  >
    <div class="breadcrumb-title">
      <div
        class="title-start"
        :class="{ 'title-start-before': $route.path !== '/homePage' }"
        :style="$route.path == '/homePage' ? 'cursor: auto;' : ''"
        @click="goHomePage"
      >
        {{ $route.path == "/homePage" ? "首页" : "首页" }}
      </div>
      <div
        class="title-mid"
        :style="$route.path == '/homePage' ? 'color: #222; font-weight: bold;' : ''"
      >
        {{ $route.path == "/homePage" ? "-" : ">>" }}
      </div>
      <div
        class="title-end"
        :style="$route.path == '/homePage' ? 'color: #222; font-weight: bold; cursor: auto;' : ''"
      >
        {{ secondaryName }}
      </div>
    </div>
    <div
      v-if="$route.path != '/homePage'"
      class="breadcrumb-back"
      @click="routerFadeBack"
    >
      返回>>
    </div>
  </div>
</template>

<script>
/**
 * 面包屑组件
 */
import { mapState } from "vuex";
export default {
  props: {},
  data() {
    return {
      separatorPayload: "-",
      secondaryName: "商标专利交易中心",
      noNav: false,
      fromHomeMap: [
        "/brokerHome",
      ] // 定义返回Home特定路由, 不然默认都返回到上一级
    };
  },
  computed: {
    
  },
  watch: {
    $route: {
      handler() {
        this.secondaryName = (this.$route.meta && this.$route.meta.breadCrumbName) || "默认路由";
        this.noNav = (this.$route.meta && this.$route.meta.isNoNav) || false;
      },
      immediate: true
    }
  },
  methods: {
    // 返回首页
    goHomePage() {
      if (this.$route.path == "/homePage") return;
      this.$router.push("/homePage");
    },
    // 返回
    routerFadeBack() {
      if (this.fromHomeMap.includes(this.$route.path)) {
        this.$router.push("/homePage");
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.g-breadcrumb {
  width: 100%;
  min-width: 1280px;
  background-color: #fff;
  padding: 15px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  // ::v-deep .el-breadcrumb__inner {
  //   font-weight: bold;
  //   font-size: $font-size-medium;
  //   color: #000;
  // }
  // ::v-deep .el-breadcrumb__separator {
  //   font-weight: bold;
  //   font-size: $font-size-medium;
  //   color: #000;
  //   margin: 0 4px;
  // }
  .breadcrumb-title {
    position: relative;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    .title-start {
      cursor: pointer;
      color: #222;
      font-weight: bold;
    }
    .title-start-before {
      padding-left: 12px;
    }
    .title-start-before::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0px;
      width: 4px;
      height: 14px;
      background-color: #ff7200;
      border-radius: 2px;
    }
    .title-mid {
      margin: 0 5px;
    }
    .title-end {
      cursor: pointer;
      color: #666;
    }
  }
  .breadcrumb-back {
    font-size: 14px;
    color: #999;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>